import { render, staticRenderFns } from "./ThemeWrapper.vue?vue&type=template&id=50d322df&"
import script from "./ThemeWrapper.vue?vue&type=script&lang=ts&"
export * from "./ThemeWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports